import { useEffect, useState } from "react";
import { GET_REQUEST } from "../../HooksApi/useApi";
import UseGetData from "../../HookAxios/getdata";
const HooksHeader = () => {
  const {
    isLoading: LoadingCourse,
    data: dataCourse,
    isError: isErrorCourse,
    error: errorCourse,
    isFetching: fetchCourse,
    refetch: refetchCourse,
  } = GET_REQUEST({
    queryKey: "getExploreCourse",
    request: () => UseGetData("get_explore_courses", { search: "تاسع" }),
    enabled: true,
  });
  const {
    isLoading: LoadingCourse2,
    data: dataCourse2,
    isError: isErrorCourse2,
    error: errorCourse2,
    refetch: refetchCourse2,
  } = GET_REQUEST({
    queryKey: "getExploreCourse2",
    request: () =>
      UseGetData("get_explore_courses", { search: "بكلوريا علمي" }),
    enabled: false,
  });
  const {
    isLoading: LoadingCourse3,
    data: dataCourse3,
    isError: isErrorCourse3,
    error: errorCourse3,
    refetch: refetchCourse3,
  } = GET_REQUEST({
    queryKey: "getExploreCourse3",
    request: () =>
      UseGetData("get_explore_courses", { search: "بكلوريا أدبي" }),
    enabled: false,
  });
  const [value, setValue] = useState("تاسع");
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    if (value === "بكلوريا علمي") refetchCourse2();
    else if (value === "بكلوريا أدبي") refetchCourse3();
  }, [value]);

  return {
    value,
    handleChange,
    dataCourse,
    LoadingCourse,
    dataCourse2,
    LoadingCourse2,
    dataCourse3,
    LoadingCourse3,
    fetchCourse,
  };
};

export default HooksHeader;
